export default __webpack_public_path__ + "static/media/b4.c61f9865.svg";